import { WritableSignal } from '@angular/core';
import { ViewPreferencesService } from './view-preferences.service';

/** Seule préférence persistée de la sidenav : le mode desktop. `closed` est un état de session mobile. */
export type DesktopSidebarMode = 'expanded' | 'collapsed';

const LEGACY_KEY = 'sidebarMode';

const isDesktopMode = (v: unknown): v is DesktopSidebarMode | null => v === null || v === 'expanded' || v === 'collapsed';

/** Valeur de l'ancienne clé `sidebarMode`, si elle est valide (sinon null). */
export function readLegacySidebarMode(storage: Pick<Storage, 'getItem'> | null): DesktopSidebarMode | null {
  try {
    const raw = storage?.getItem(LEGACY_KEY);
    return raw === 'expanded' || raw === 'collapsed' ? raw : null;
  } catch {
    return null;
  }
}

/**
 * Préférence « mode de la sidenav » via `ViewPreferencesService` (clé `mokah.pref.browser.sidebarMode`,
 * par navigateur). Migration douce (MOKA-349) : si la nouvelle clé est absente, l'ancienne clé
 * `sidebarMode` est relue une fois et recopiée dans la nouvelle ; l'ancienne n'est plus écrite.
 */
export function sidebarModePref(prefs: ViewPreferencesService): WritableSignal<DesktopSidebarMode | null> {
  const pref = prefs.pref<DesktopSidebarMode | null>('sidebarMode', null, { scope: 'browser', validate: isDesktopMode });
  if (pref() === null) {
    let legacy: DesktopSidebarMode | null = null;
    try {
      legacy = readLegacySidebarMode(localStorage);
    } catch {
      /* stockage bloqué */
    }
    if (legacy) pref.set(legacy);
  }
  return pref;
}
